import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRangeHandle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 32,
	viewBox: "0 0 8 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 1.6C8 0.716345 7.28366 0 6.4 0V0C2.86538 0 0 2.86538 0 6.4V25.6C0 29.1346 2.86538 32 6.4 32V32C7.28366 32 8 31.2837 8 30.4V1.6Z" })
});
export default SvgRangeHandle;
